import { SuccessButton } from 'components/button';
import React from 'react';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { redirectToHome } from '__utils/common-utils';
import errorPage from 'images/error-page.png';
import { CommonStyledComponentProps } from '__utils/type';
import CopyrightInfomration from 'components/copyright-information';
import { WhiteCardWrapper } from 'views/common-styled-components';

const TransactionErrorOuterCont = styled.div<CommonStyledComponentProps>`
    padding: 17px;
    margin: 17px;
    background-color: ${COLOR.WHITE};
    .footer {
        background: #fff;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 8px;
        box-shadow: 0 2px 4px 4px ${COLOR.LIGHTGREY};
        z-index: 1050;
    }
`;
const MobileSubmitButton = styled(SuccessButton)`
        width: 25%;
	    margin: 30px auto;
        display: block;
        text-align: center;
	    height: 40px;
	    border-radius: 4px;

`;
/* goBackCallback: redirectToHome,
title: `Cheque payment details`, */
const TransactionError: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    return (
        <div>
            <WhiteCardWrapper isMobile={ isMobile }>
                <TransactionErrorOuterCont isMobile={ isMobile }>
                    <div>
                        <div>
                            <div className="error-page">
                                <img src={ errorPage } alt="error-page" />
                                <h4>Ooops !</h4>
                                <p>Something went wrong.</p>
                                <p>If you need any help or have any query just write to us at <a href="mailto:help@turtlemintmoney.com" style={ { color: "#0268ed" } }>help@turtlemintmoney.com</a> or call us at: <a href="tel:18002666468" style={ { color: "#0268ed" } }>18002666468</a>.</p>
                                {/* <button className="mint-btn bg-green" ng-click="goHomeClick('transaction-error')">Explore Mutual Funds</button> */ }
                                <div className={ isMobile ? "footer" : "" }>
                                    { isMobile ? <SuccessButton onClick={ () => redirectToHome() }>Explore Mutual Funds</SuccessButton> : <MobileSubmitButton onClick={ () => redirectToHome() }>Explore Mutual Funds</MobileSubmitButton> }
                                </div>
                            </div>
                        </div>
                    </div>
                </TransactionErrorOuterCont>
            </WhiteCardWrapper>
            <CopyrightInfomration isMobile={ isMobile } />
        </div>);
};

export default TransactionError;